import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoText = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 196,
	height: 19,
	viewBox: "0 0 196 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M73.4757 19V0H88V4.24845H79.0711V7.34627H86.8988V11.6537H79.0711V14.7516H88V19H73.4757Z",
			fill: "#1E293B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4999 19V0H63.0716C65.036 0 66.7126 0.324535 68.1015 0.973604C69.4905 1.603 70.552 2.62578 71.2862 4.04193C72.0203 5.43841 72.3874 7.2971 72.3874 9.61801C72.3874 12.883 71.5838 15.2629 69.9766 16.7578C68.3694 18.2526 66.0677 19 63.0716 19H54.4999ZM60.0953 14.7516H62.3573C63.2899 14.7516 64.0736 14.6237 64.7086 14.368C65.3435 14.0926 65.8296 13.5911 66.167 12.8634C66.5043 12.1159 66.6729 11.0342 66.6729 9.61801C66.6729 8.20186 66.5142 7.11025 66.1967 6.34317C65.8991 5.55642 65.4328 5.01553 64.7979 4.7205C64.1629 4.4058 63.3494 4.24845 62.3573 4.24845H60.0953V14.7516Z",
			fill: "#1E293B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.5995 19V0H46.5701C48.1376 0 49.4174 0.285197 50.4095 0.855591C51.4214 1.42598 52.1754 2.22257 52.6715 3.24534C53.1675 4.24845 53.4156 5.41874 53.4156 6.75621C53.4156 8.03468 53.0882 9.16563 52.4334 10.1491C51.7984 11.1128 50.9452 11.8504 49.8738 12.3618C50.092 12.5388 50.2805 12.7552 50.4393 13.0109C50.598 13.2469 50.7766 13.5813 50.975 14.014L53.1775 19H47.3439L45.32 14.427C45.1613 14.073 44.9629 13.8271 44.7248 13.6894C44.5065 13.5321 44.189 13.4534 43.7724 13.4534H42.1949V19H36.5995ZM42.1949 9.20497H45.1415C45.955 9.20497 46.58 8.99845 47.0165 8.5854C47.4729 8.15269 47.7011 7.54296 47.7011 6.75621C47.7011 5.08437 46.9074 4.24845 45.32 4.24845H42.1949V9.20497Z",
			fill: "#1E293B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.2859 19V0H35.8102V4.24845H26.8814V7.34627H34.709V11.6537H26.8814V14.7516H35.8102V19H21.2859Z",
			fill: "#1E293B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.35145 19L0 0H5.83354L10.298 12.5683L14.7624 0H20.6257L13.2743 19H7.35145Z",
			fill: "#1E293B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M180.948 19V0H189.806C191.96 0 193.526 0.550725 194.504 1.65217C195.501 2.73395 196 4.20911 196 6.07764C196 7.41511 195.661 8.5559 194.983 9.5C194.304 10.4441 193.327 11.103 192.05 11.4767C192.409 11.7324 192.688 12.0078 192.888 12.3028C193.087 12.5978 193.287 12.9912 193.486 13.4829L195.91 19H192.559L190.195 13.6894C189.975 13.1781 189.706 12.8142 189.387 12.5978C189.087 12.3815 188.569 12.2733 187.831 12.2733H184.21V19H180.948ZM184.21 9.67702H188.938C190.115 9.67702 191.042 9.39182 191.721 8.82143C192.399 8.25104 192.738 7.33644 192.738 6.07764C192.738 3.69772 191.571 2.50776 189.237 2.50776H184.21V9.67702Z",
			fill: "#1E293B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M165.492 19V0H178.929V2.50776H168.754V8.26087H177.822V10.7391H168.754V16.5217H178.929V19H165.492Z",
			fill: "#1E293B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M147.056 19V0H154.867C157.72 0 159.834 0.747412 161.211 2.24224C162.587 3.71739 163.276 6.17598 163.276 9.61801C163.276 12.8634 162.597 15.2433 161.241 16.7578C159.884 18.2526 157.759 19 154.867 19H147.056ZM150.318 16.5217H154.358C155.615 16.5217 156.662 16.3447 157.5 15.9907C158.338 15.617 158.966 14.9286 159.385 13.9255C159.804 12.9224 160.014 11.4865 160.014 9.61801C160.014 7.74948 159.824 6.30383 159.445 5.28106C159.066 4.25828 158.458 3.54037 157.62 3.12733C156.802 2.71429 155.715 2.50776 154.358 2.50776H150.318V16.5217Z",
			fill: "#1E293B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.532 19L133.894 0H137.544L144.846 19H141.494L139.579 14.1025H131.829L129.913 19H126.532ZM132.337 11.6242H139.041L135.689 2.92081L132.337 11.6242Z",
			fill: "#1E293B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.178 19V0H120.035C122.19 0 123.756 0.550725 124.734 1.65217C125.731 2.73395 126.23 4.20911 126.23 6.07764C126.23 7.41511 125.891 8.5559 125.212 9.5C124.534 10.4441 123.557 11.103 122.28 11.4767C122.639 11.7324 122.918 12.0078 123.118 12.3028C123.317 12.5978 123.517 12.9912 123.716 13.4829L126.14 19H122.788L120.424 13.6894C120.205 13.1781 119.936 12.8142 119.616 12.5978C119.317 12.3815 118.799 12.2733 118.06 12.2733H114.439V19H111.178ZM114.439 9.67702H119.168C120.345 9.67702 121.272 9.39182 121.951 8.82143C122.629 8.25104 122.968 7.33644 122.968 6.07764C122.968 3.69772 121.801 2.50776 119.467 2.50776H114.439V9.67702Z",
			fill: "#1E293B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.165 19V2.50776H94V0H109.561V2.50776H103.426V19H100.165Z",
			fill: "#1E293B"
		})
	]
});
export default SvgLogoText;
